import * as React from "react";
const Loader = require("react-loader-spinner").default;
import { toast } from "react-toastify";

import "react-datepicker/dist/react-datepicker.css";
import Edit from "./Edit";
import Filter from "./Filter";
import Export from "./Export";
import * as moment from "moment";
import hash from "../../assets/hash.png"

export default class Users extends React.Component<any, any> {
  searchInput: string;
  constructor(props: any) {
    super(props);
    this.state = {
      users: [],
      loading: false,
      activeUser: null,
      showMore: false,
      cities: [],
      categories: [],
      exportColumns: [],
      page: 0
    };
  }

  componentDidUpdate(nextProps: any) {
    if (nextProps.international !== this.props.international) {
      this.loadUsers();
    }
  }

  filter = (filter: any) => {
    this.setState({ loading: true });
    filter.international = this.props.international;
    fetch("users/filter", {
      method: "POST",
      body: JSON.stringify({ filter }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let users = data.users;
        this.setState({ users, loading: false });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  search = (e: any) => {
    if (e.keyCode === 13) {
      if (this.searchInput?.length > 1) {
        fetch("users/search", {
          method: "POST",
          body: JSON.stringify({
            search: this.searchInput,
            international: this.props.international,
          }),
        })
          .then((results) => {
            return results.json();
          })
          .then((data) => {
            let users = data.users;
            this.setState({ users, loading: false });
          })
          .catch((err) => {
            this.setState({ loading: false });
            toast.error(err.message);
          });
      } else {
        this.loadUsers();
      }
    } else {
      this.searchInput = e.target.value;
    }
  };

  loadUsers = () => {
    this.setState({ loading: true });
    fetch("users/getAll", {
      method: "POST",
      body: JSON.stringify({ international: this.props.international, page: this.state.page }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ loading: false, users: data.users});
      })
      .catch((err) => {
        this.setState({ loading: false });

        toast.error(err.message);
      });
  };

  loadCategories = () => {
    fetch("categories/getAll", {
      method: "POST",
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ categories: data.categories });
      })
      .catch((err) => {
        //alert(err.message);
      });
  };

  loadCities = () => {
    fetch("users/getCities", {
      method: "POST",
      body: JSON.stringify({ international: this.props.international }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        this.setState({ cities: data.cities });
      })
      .catch((err) => {
        //alert(err.message);
      });
  };

  removeUser = (id: number, index: number) => {
    this.setState({ loading: true });
    const confirmed = confirm("לא ניתן לשחזר משפיען שנמחק");
    if(!confirmed) return;
    fetch("users/delete", {
      method: "POST",
      body: JSON.stringify({ id }),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let users = this.state.users;
        users.splice(index, 1);
        this.setState({
          loading: false,
          users,
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        toast.error(err.message);
      });
  };

  updateUser = (newUser: any) => {
    this.setState({ loading: true });
    newUser.international = this.props.international;
    fetch("users/edit", {
      method: "POST",
      body: JSON.stringify(newUser),
    })
      .then((results) => {
        return results.json();
      })
      .then((data) => {
        let users = this.state.users;
        if (newUser.id) {
          const i = users.findIndex((u: any) => {
            return u.id === newUser.id;
          });
          users[i] = data.user;
        } else {
          users.unshift(data.user);
        }
        this.setState({
          loading: false,
          users,
          activeUser: null,
        });
      })
      .catch((err) => {
        this.setState({ loading: false, activeUser: null });
        toast.error(err.message);
      });
  };

  componentDidMount() {
    this.loadUsers();
    this.loadCategories();
    this.loadCities()
  }

  public render() {
    const { cities, categories, activeUser } = this.state;
    return (
      <div id="users-root">
        {this.state.loading && (
          <div className="loading">
            <Loader
              type="Oval"
              className="loader"
              color="#2f98e0"
              height={100}
              width={100}
            />
          </div>
        )}
        <div className="buttonsHeader single">
          <i className="fa fa-bars" onClick={() => {this.props.openMenu()}}></i>
          <h1><img src={hash}></img>משפיענים {this.props.international? "חו״ל" : ""}</h1>
          <div className="buttonsDiv">
          {window.innerWidth > 768 && <button
            onClick={() => {
              this.setState({ showMore: !this.state.showMore });
            }}
            style={{ float: "left" }}
          >
            {this.state.showMore ? "הסתרת עמודות" : "הצגת עמודות"}
          </button>}
          <Export />
          <Edit
            updateUser={this.updateUser}
            activeUser={activeUser}
            categories={categories}
            resetActive={() => {
              this.setState({ activeUser: null });
            }}
          />
          <Filter
            filter={this.filter}
            categories={categories}
            cities={cities}
          />
          <div className="clearfix"></div>
        </div>
        </div>
        <input
          className="globalSearch"
          placeholder="חיפוש כללי לפי שם/קטגוריה/תת קטגוריה/עיר"
          onKeyDown={(e) => {
            this.search(e);
          }}
        ></input>
        <div className="board" style={{overflowX: "scroll"}}>
        {this.state.users.map((user:any, i:number) => {
          return (
            <div className="user-row white-box" key={i}>
                  <div className="scroller" style={{width: this.state.showMore? "2470px" : "1690px"}}>
                  <a
                    target="_blank"
                    href={user.socialUrl}
                  >
                        {user.type === "instagram" && (
                          <i className="fab fa-instagram"></i>
                        )}
                        {user.type === "facebook" && (
                          <i className="fab fa-facebook"></i>
                        )}
                  </a>
                  <div className="info" style={{width: "150px"}}>
                    <label>שם</label>
                    <span>{user.name}</span>
                  </div>
                  <div className="info">
                    <label>עוקבים</label>
                    <span>{user.followers}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>קטגוריה</label>
                    <span>{user.category?.title || "-"}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>תת קטגוריה</label>
                    <span>{user.subCategory || "-"}</span>
                  </div>
                  <div className="info">
                    <label>גיל</label>
                    <span>{user.birthDate
                    ? moment().diff(
                        moment(user.birthDate, "YYYY-MM-DD"),
                        "years"
                      ) : "" || "-"}</span>
                  </div>
                  <div className="info">
                    <label>מין</label>
                    <span>{user.sex === "male"? "זכר" : "נקבה"}</span>
                  </div>
                  <div className="info">
                    <label>עיר</label>
                    <span>{user.city || "-"}</span>
                  </div>
                  <div className="info">
                    <label>₪ לפיד</label>
                    <span>{user.feedPrice? user.feedPrice.toLocaleString() + "₪" : "-"}</span>
                  </div>
                  <div className="info" style={{width: "140px"}}>
                    <label>₪ פעימת סטורי</label>
                    <span>{user.storyPrice? user.storyPrice.toLocaleString() + "₪" : "-"}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>% מעורבות</label>
                    <span>{user.engagementPercentage? user.engagementPercentage +"%" : "-"}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>ממוצע צפיות</label>
                    <span>{user.viewsPercentage? user.viewsPercentage.toLocaleString() : "-"}</span>
                  </div>
                  <div className="info">
                    <label>הקלקות</label>
                    <span>{user.clicks || "-"}</span>
                  </div>
                  <div className="info" style={{width: "120px"}}>
                    <label>טלפון</label>
                    {user.phone? <a
                      target="_blank"
                      href={`https://web.whatsapp.com/send?phone=${user.phone}`}
                    >
                      {user.phone}
                    </a> : (<span>-</span>)}
                  </div>
                  <div className={this.state.showMore? "info" : "info no-after"}>
                    <label>סוכנות</label>
                    <span>{user.agency || "-"}</span>
                  </div>
                  {this.state.showMore && <>
                    <div className="info">
                      <label>18-25</label>
                      <span>{user.teenFollowers? user.teenFollowers.toLocaleString() : "-"}</span>
                    </div>
                    <div className="info">
                      <label>25-35</label>
                      <span>{user.youngFollowers? user.youngFollowers.toLocaleString() : "-"}</span>
                    </div>
                    <div className="info">
                      <label>35-45</label>
                      <span>{user.adultFollowers? user.adultFollowers.toLocaleString() : "-"}</span>
                    </div>
                    <div className="info" style={{width: "120px"}}>
                      <label>% ישראלים</label>
                      <span>{user.israeliPercentage? user.israeliPercentage +"%" : "-"}</span>
                    </div>
                    <div className="info" style={{width: "120px"}}>
                      <label>% מזויפים</label>
                      <span>{user.fakePercentage? user.fakePercentage +"%" : "-"}</span>
                    </div>
                    <div className="info">
                      <label>% גברים</label>
                      <span>{user.malePercentage? user.malePercentage +"%" : "-"}</span>
                    </div>
                    <div className="info">
                      <label>% נשים</label>
                      <span>{user.femalePercentage? user.femalePercentage +"%" : "-"}</span>
                    </div>
                    <div className="info no-after">
                      <label>קופ״ח</label>
                      <span>{user.insurance || "-"}</span>
                    </div>
                  </>}
                  <div className="settings info">
                    <label>הגדרות</label>
                    <i
                      className="fas fa-edit"
                      onClick={() => {
                        this.setState({ activeUser: user.id });
                      }}
                    ></i>
                    <i
                      onClick={() => {
                        this.removeUser(user.id, i);
                      }}
                      className="fas fa-trash-alt"
                    ></i>
                  </div>
                  </div>
            </div>
          )
        })}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/Users.tsx